export default "__VITE_ASSET__R3MyfOe8__"